import type { SortConfig, TransformRow } from './types';

function toNumber(v: unknown): number {
  if (typeof v === 'number') return v;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function sumValues(row: TransformRow): number {
  let sum = 0;
  for (const v of Object.values(row)) {
    if (typeof v === 'number') sum += v;
  }
  return sum;
}

export function sortRows(
  rows: TransformRow[],
  config: SortConfig,
): TransformRow[] {
  const multiplier = config.direction === 'desc' ? -1 : 1;
  const { sortBySeries } = config;
  return [...rows].sort((a, b) => {
    const av = sortBySeries ? toNumber(a[sortBySeries]) : sumValues(a);
    const bv = sortBySeries ? toNumber(b[sortBySeries]) : sumValues(b);
    return (av - bv) * multiplier;
  });
}
